// @ts-nocheck

import React, { useCallback } from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { Target } from '../../../../client';
import ScrollView from '../../../../components/ScrollView';

import Filter from './Filter';

const Wrap = styled.div`
  margin: 1em 0 0;
  padding: 0 0.6em;
`;

const InnerWrap = styled.div`
  display: inline-block;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

const List = styled.div`
  position: relative;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
`;

const StyledFilter = styled(Filter)`
  &&&& {
    box-sizing: border-box;
    margin: ${Target.__MOBILE__ ? '0 0.4em 1em' : '1em'};
    width: ${Target.__MOBILE__ ? '100%' : 'calc(100% - 2em)'};
    padding: 1em;
  }
`;

type GridsFiltersProps = {
  className?: string;
  currentFilterId: string;
  setFilter: (filterId: string) => void;
  filters: Array<{
    id: string;
    label: string;
  }>;
};

const GridsFilters = ({ className, filters, currentFilterId, setFilter }: GridsFiltersProps) => {
  const renderFilters = useCallback(() => {
    return filters.map<Node>(({ id, label }) => (
      <StyledFilter key={id} isSelected={id === currentFilterId} onClick={() => setFilter(id)}>
        {label}
      </StyledFilter>
    ));
  }, [currentFilterId, filters, setFilter]);
  return Target.__MOBILE__ ? (
    <Wrap className={className}>
      <ScrollView vertical={false}>
        <InnerWrap>
          <List>{renderFilters()}</List>
        </InnerWrap>
      </ScrollView>
    </Wrap>
  ) : (
    renderFilters()
  );
};

export default GridsFilters;
